import type { Operation } from './operation.enum';
import type { IntegrationState } from './integration-state.enum';

export interface IntegrationStatusDto {
  id: number;
  operation?: Operation;
  description?: string;
  state?: IntegrationState;
  lastExecution?: string;
  attempts: number;
}
